import React, { Component } from 'react';
import JsonTable from 'ts-react-json-table';
import * as dictionary from './Dictionary';
import './Report.css';


class Report extends Component {

    render() {
        const settings = {header: false};
        const generalInfoItems = this._getGeneralInfoTableItems();
        const backgroundItems = this._getBackgroundDiseaseTableItems();
        const woundInfoItems = this._getWoundInfoTableItems();
        const limbItems = this._getLimbTableItems();
        const woundTaggingItems = this._getWoundTaggingTableItems();
        const signItems = this._getSignItems();
        return(
            <div className="report-wrapper">
                <div className="page-header">:מסמך מקור מספר 2</div>
                <div className="page-title">מידע כללי על המשתתף</div>
                <div className="table-title"></div>
                <JsonTable rows={generalInfoItems} settings={settings} className="main-table"/>
                <div className="table-title"></div>
                <JsonTable rows={backgroundItems} settings={settings} className="main-table"/>
                <div className="page-footer">38</div>
                <div className="html2pdf__page-break"></div>
                <div className="page-header">:מסמך מקור מספר 3</div>
                <div className="page-title">נתונים על הפצע הנסרק</div>
                <div className="table-title">:פצע</div>
                <JsonTable rows={woundInfoItems} settings={settings} className="main-table"/>
                <div className="table-title">:גפה</div>
                <JsonTable rows={limbItems} settings={settings} className="main-table"/>
                <div className="page-footer">39</div>
                <div className="html2pdf__page-break"></div>
                <div className="page-header">:מסמך מקור מספר 4</div>
                <div className="page-title">(תיוג הפצע הנסרק )בדיקת הקלינאי</div>
                <div className="table-title">:פצע</div>
                <JsonTable rows={woundTaggingItems} settings={settings} className="main-table"/>
                <JsonTable rows={signItems} settings={settings} className="sign-table"/>
                <div className="page-footer">40</div>
            </div>
        )
    }

    _getGeneralInfoTableItems = () => {
        const anamnesis = this.props.reportFields.anamnesis;
        return [
            {"value": this._getDateFromTimestamp(this.props.reportFields.timestamp), "key": dictionary["date"]},
            {"value": anamnesis.patient_token, "key": dictionary["patient_token"]},
            {"value": this.props.reportFields.tags.clinician, "key": dictionary["clinician"]},
            {"value": this.props.reportFields.tags.operator, "key": dictionary["operator"]},
            {"value": dictionary[anamnesis.gender], "key": dictionary["gender"]},
            {"value": (new Date()).getFullYear() - anamnesis.year_of_birth, "key": dictionary["age"]}
        ];
    };

    _getBackgroundDiseaseTableItems = () =>  {
        const value = this.props.reportFields.anamnesis.background_diseases.length === 0 ? dictionary.null : this.props.reportFields.anamnesis.background_diseases.join(", ");
         return [
            {"value": value, "key": dictionary["background_diseases"]}
        ];
    };

    _getWoundInfoTableItems = () =>  {
        const anamnesis = this.props.reportFields.anamnesis;
        return [
            {"value": this._getWoundLocation(anamnesis.wound_location), "key": dictionary["wound_location"]},
            {"value": anamnesis.number_of_wounds || dictionary.null, "key": dictionary["number_of_wounds"]},
            {"value": this._getDateFromTimestamp(anamnesis.wound_appearance_date), "key": dictionary["wound_appearance_date"]},
            {"value": this._getDateFromTimestamp(anamnesis.wound_treatment_date), "key": dictionary["wound_treatment_date"]},
            {"value": dictionary[anamnesis.wound_type], "key": dictionary["wound_type"]},
            {"value": dictionary[anamnesis.offensive_smell], "key": dictionary["offensive_smell"]},
            {"value": anamnesis.pain_level || dictionary.null, "key": dictionary["pain_level"]},
            {"value": dictionary[anamnesis.secretion_amount] + ', '
                + dictionary[anamnesis.secretion_characteristics], "key": dictionary["secretion"]}
        ];
    };

     _getLimbTableItems = () =>  {
        const anamnesis = this.props.reportFields.anamnesis;
        return [
            {"value": dictionary[anamnesis.peripheral_pulse], "key": dictionary["peripheral_pulse"]},
            {"value": dictionary[anamnesis.edema], "key": dictionary["edema"]},
            {"value": dictionary[anamnesis.secondary_infection], "key": dictionary["secondary_infection"]},
            {"value": dictionary[anamnesis.temperature], "key": dictionary["temperature"]}
        ];
    };

     _getWoundTaggingTableItems = () =>  {
        const anamnesis = this.props.reportFields.anamnesis;
        return [
            {"value": anamnesis.wound_length || dictionary.null, "key": dictionary["wound_length"]},
            {"value": anamnesis.wound_width || dictionary.null, "key": dictionary["wound_width"]},
            {"value": anamnesis.wound_depth || dictionary.null, "key": dictionary["wound_depth"]},
            {"value": this._getTissuesSegmentation(anamnesis.tissues_segmentation), "key": dictionary["tissues_segmentation"]},
            {"value": dictionary[anamnesis.edges], "key": dictionary["edges"]},
            {"value": dictionary[anamnesis.pass_treatment], "key": dictionary["pass_treatment"]}
        ];
    };

    _getSignItems = () =>  {
        return [
            {"value": ":חתימת רופא", "key": ":תאריך"},
            {"value": "--------------------------", "key": "----------------------"}
        ];
    };

    _getDateFromTimestamp = (timestamp) =>  {
        if (!timestamp)
            return dictionary.null;
        const dateObj = new Date(timestamp*1000);
        const date = dateObj.getDate() + '-' + Number(dateObj.getMonth()+1) + '-' + dateObj.getFullYear();
        return date;
    };

    _getWoundLocation = (woundProps) =>  {
         if (!woundProps)
            return dictionary.null;
        const area = woundProps.area === '' ? '' : dictionary[woundProps.area];
        return dictionary[woundProps.organ] + ' ' + dictionary[woundProps.side] + ' ' + dictionary[woundProps.orientation] + ' ' + area;
    };

    _getTissuesSegmentation = (tissuesSegmentation) => {
        let str = '';
        Object.keys(tissuesSegmentation).forEach( key => {
            if (tissuesSegmentation[key] !== 0)
                str += dictionary[key] + ' ' + tissuesSegmentation[key] + '%, ';
        });
        return str === '' ? dictionary.null : str;
    };

 }

export default Report;


// WEBPACK FOOTER //
// ./src/Report.jsx